import { BoxProps } from 'UIKit/Box/types'
import Column from 'layout/Components/Column'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import useAuthenticationModal from 'hooks/useAuthenticationModal'
import useKeydownEventListener from 'hooks/useKeydownEventListener'

import { Trans } from 'react-i18next'
import { useAuth } from 'state/auth/hooks'

import { TokenAmount } from 'config/types'
import { InHouseGameButton, MineAnimation } from 'views/InhouseGame/components/styled'
import { InhouseGameBetResult } from 'views/InhouseGame/config/types'
import { useMineGameStatus } from '../../hooks'
import MineEstimateProfit from './MineEstimateProfit'
import MinesSelect from './components/MinesSelect'

const MineBetAction: React.FC<
  {
    disabled: boolean
    onBet: () => Promise<InhouseGameBetResult>
    hotkeyEnable?: boolean
  } & BoxProps
> = ({ disabled, hotkeyEnable, onBet, ...props }) => {
  const { isPlaying } = useMineGameStatus()
  const { hasSession } = useAuth()
  const [isBetting, setIsBetting] = useState(false)

  const [onPresentLoginModal] = useAuthenticationModal()

  const eventHandler = useCallback(
    (event) => {
      if (event && event?.key === ' ') {
        event.preventDefault()

        if (!hotkeyEnable || disabled || isPlaying || isBetting) return null

        onBet()
      }
    },
    [hotkeyEnable, disabled, isPlaying, isBetting, onBet],
  )
  useKeydownEventListener(eventHandler)

  const handleBet = async () => {
    setIsBetting(true)
    const result = await onBet()
    if (result !== InhouseGameBetResult.Succeed) {
      setIsBetting(false)
    }
  }
  return (
    <Column {...props}>
      {hasSession ? (
        <StyledButton disabled={disabled || isPlaying || isBetting} onClick={handleBet}>
          {isPlaying || isBetting ? <MineAnimation /> : <Trans>Bet</Trans>}
        </StyledButton>
      ) : (
        <StyledButton onClick={onPresentLoginModal}>
          <Trans>Login and Play</Trans>
        </StyledButton>
      )}
    </Column>
  )
}

const MineManualBet: React.FC<
  BoxProps & {
    disabled?: boolean
    mines: number
    setMines: (mines: number) => void
    hotkeyEnable: boolean
    onBet: () => Promise<InhouseGameBetResult>
    betAmount: TokenAmount
  }
> = ({ hotkeyEnable, disabled, betAmount, mines, setMines, onBet, ...props }) => {
  return (
    <StyledWrapper {...props}>
      <Column>
        <MinesSelect mines={mines} onSelect={setMines} mb="24px" />

        <MineEstimateProfit width="100%" mb="16px" mines={mines} betAmount={betAmount} />
      </Column>

      <MineBetAction
        mt="12px"
        mb={['64px', '', '', '', '0px']}
        hotkeyEnable={hotkeyEnable}
        disabled={disabled}
        onBet={onBet}
      />
    </StyledWrapper>
  )
}

const StyledWrapper = styled(Column)``

const StyledButton = styled(InHouseGameButton)`
  min-height: 42px !important;
  max-height: 42px !important;
`

export default MineManualBet
